import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const fmConfig: TSPConfig = {
  key: 'fm',
  name: 'FM',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API key from your FM ELD representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default fmConfig;
